
import * as icons from '@mdi/js'

export default {
  columnClass: 'p-2 text-left',
  components: {},
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  icons,
  computed: {
    md () {
      if (this.section.columnFour) {
        return 3
      }
      if (this.section.columnThree) {
        return 4
      }
      if (this.section.columnTwo) {
        return 6
      }

      return 12
    },
    imageSrc () {
      try {
        const originSlash = /^https?:\/\/[^/]+\//i
        return this.section.image.image.data.attributes.url.replace(originSlash, '')
      } catch (e) {
        return ''
      }
    }
  }
}
